import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {catchError, retry} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {Observable, of} from 'rxjs';
import { NotesSet } from '../model/notesSet';
import { NotesDetails } from '../model/notesDetails';
import { GlobalErrorHandlingService } from '../ErrorHandler/GlobalErrorHanding.service';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': 'my-auth-token'
  })
};

const GET_ALL_NOTES_BY_NOTES_SET_ID_URI: string = environment.API_URL + '/notes/find';
const CREATE_NOTES_BY_NOTES_SET_ID_URI: string = environment.API_URL + '/notes/create';



@Injectable()
export class NotesService {


 constructor(private http: HttpClient,  private errorService: GlobalErrorHandlingService ) {}

  // Get All Notes by NotesSetID
  getNotesByNotesSetId(noteSetId: number): Observable<NotesSet[]> {
    const url = GET_ALL_NOTES_BY_NOTES_SET_ID_URI + `/${noteSetId}`;
   // console.log(url);
    return this.http.get<NotesSet[]>(url)
      .pipe(
        catchError(this.errorService.handleError('Not Found Type Error', [])) // then handle the error
      );
  }

  // Create ConsularService
  createNotesDetailsByNotesSetId(notesDetails: NotesDetails, noteSetId: number ): Observable<NotesDetails> {
    const url = CREATE_NOTES_BY_NOTES_SET_ID_URI + `/${noteSetId}`;
    return this.http.post<NotesDetails>(url, notesDetails, httpOptions)
      .pipe(
        catchError(this.errorService.handleError('Not Found Type Error', new NotesDetails())) // then handle the error
      );
  }
}
